module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Italic.9007f591.eot";